var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"technology-name-table-cell",attrs:{"title":_vm.fullTechnologyName},on:{"click":() => { _vm.$emit("click") }}},[_vm._v(" "+_vm._s(_vm.fullTechnologyName)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }